import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { UniDriver } from '@wix/unidriver-core';

export const draggableContainerUniDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
  };
};

export type DraggableContainerUniDriver = ReturnType<
  typeof draggableContainerUniDriverFactory
>;
